import type { GenericAction } from '../types/actions';

export interface SignL1ActionParams {
  action: GenericAction;
  nonce: number;
  actionHash: `0x${string}`;
  isTestnet: boolean;
}

/**
 * Abstract signing adapter interface
 * Implementations handle platform-specific signing (React hooks, RPC, etc.)
 */
export abstract class SigningAdapter {
  /**
   * Sign an L1 action for Hyperliquid
   * Returns the signature as a hex string
   */
  abstract signL1Action(params: SignL1ActionParams): Promise<`0x${string}`>;

  /**
   * Check if the adapter is ready to sign
   */
  abstract isReady(): Promise<boolean>;

  /**
   * Get the wallet address associated with this adapter
   */
  abstract getWalletAddress(): string;
}
